import * as tslib_1 from "tslib";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Checkable from '../Checkable';
import "./Switcher.css";
var id = 1;

var getId = function getId() {
  return "nx-switcher-filter-" + id++;
};

var Switcher =
/** @class */
function (_super) {
  tslib_1.__extends(Switcher, _super);

  function Switcher() {
    var _this = _super !== null && _super.apply(this, arguments) || this; // this id is unique for every instance


    _this.uuid = getId();

    _this.renderShadowFilter = function (size, checked) {
      return React.createElement("defs", null, React.createElement("filter", {
        id: _this.uuid,
        x: checked ? '-3' : '0',
        y: "0",
        width: size,
        height: size,
        filterUnits: "userSpaceOnUse"
      }, React.createElement("feOffset", {
        dx: checked ? '-2' : '2',
        in: "SourceAlpha"
      }), React.createElement("feGaussianBlur", {
        stdDeviation: "1",
        result: "blur"
      }), React.createElement("feFlood", {
        floodOpacity: "0.114"
      }), React.createElement("feComposite", {
        operator: "in",
        in2: "blur"
      }), React.createElement("feComposite", {
        in: "SourceGraphic"
      })));
    };

    return _this;
  }

  Switcher.prototype.render = function () {
    var _a = this.props,
        activeBgColor = _a.activeBgColor,
        checked = _a.checked,
        inactiveBgColor = _a.inactiveBgColor,
        size = _a.size,
        title = _a.title;
    var translate = checked ? "translate(" + size + " 0)" : "translate(" + size / 12 + " 0)";
    var bgColor = checked ? activeBgColor : inactiveBgColor;
    var circleSize = size * 0.9226 - size / 12;
    return React.createElement(Checkable, tslib_1.__assign({}, this.props), React.createElement("svg", {
      width: size * 1.9226,
      height: size
    }, this.renderShadowFilter(size, !!checked), React.createElement("g", null, React.createElement("rect", {
      fill: bgColor,
      width: size * 1.9226,
      height: size,
      rx: size / 2
    }), React.createElement("title", null, title), React.createElement("path", {
      filter: "url(#" + this.uuid + ")",
      transform: translate,
      fill: "#fff",
      d: "M " + circleSize / 2 + ", " + size / 2 + "\n              m -" + circleSize / 2 + ", 0\n              a " + circleSize / 2 + "," + circleSize / 2 + " 0 1,0 " + circleSize + ",0\n              a " + circleSize / 2 + "," + circleSize / 2 + " 0 1,0 -" + circleSize + ",0"
    }))));
  };

  Switcher.propTypes = {
    blockClassName: PropTypes.string,
    size: PropTypes.number,
    title: PropTypes.string,
    activeBgColor: PropTypes.string,
    inactiveBgColor: PropTypes.string,
    checked: PropTypes.bool,
    shouldPropagate: PropTypes.bool
  };
  Switcher.defaultProps = {
    blockClassName: 'nx-switcher',
    size: 20,
    activeBgColor: '#93cd4c',
    inactiveBgColor: '#ccc',
    checked: false,
    shouldPropagate: false
  };
  return Switcher;
}(Component);

export default Switcher;

try {
  // @ts-ignore
  Switcher.__docgenInfo = {
    "description": "",
    "displayName": "Switcher",
    "props": {
      "size": {
        "defaultValue": {
          value: "20"
        },
        "description": "",
        "name": "size",
        "required": true,
        "type": {
          "name": "number"
        }
      },
      "title": {
        "defaultValue": null,
        "description": "",
        "name": "title",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "activeBgColor": {
        "defaultValue": {
          value: "#93cd4c"
        },
        "description": "",
        "name": "activeBgColor",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "inactiveBgColor": {
        "defaultValue": {
          value: "#ccc"
        },
        "description": "",
        "name": "inactiveBgColor",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "blockClassName": {
        "defaultValue": {
          value: "nx-switcher"
        },
        "description": "",
        "name": "blockClassName",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "shouldPropagate": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "shouldPropagate",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "type": {
        "defaultValue": null,
        "description": "",
        "name": "type",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "disabled": {
        "defaultValue": null,
        "description": "",
        "name": "disabled",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "checked": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "checked",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "onChange": {
        "defaultValue": null,
        "description": "",
        "name": "onChange",
        "required": false,
        "type": {
          "name": "((checked: boolean, event: SyntheticEvent<Element>) => void) | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}